import { AdMobInterstitial } from 'expo-ads-admob';
import { Platform } from 'react-native';

// https://apps.admob.com/v2/apps/2547835678/adunits/list?pli=1
const AD_UNIT_ID = 'ca-app-pub-7716238237159703/9819257274';

const showAdInterstitial = async (): Promise<void> => {
	if (Platform.OS === 'web') return;

	const count = 3;
	const randomNum = Math.floor(Math.random() * count);
	if (randomNum !== 0) return;

	await AdMobInterstitial.setAdUnitID(AD_UNIT_ID);
	await AdMobInterstitial.requestAdAsync({
		servePersonalizedAds: true,
	});
	await AdMobInterstitial.showAdAsync();
};

export default showAdInterstitial;
